/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unreachable */
import { useTranslation } from "react-i18next";
import { ApplicationSvg, Complaints1Svg, ComplaintsSvg, GreenPoints, GreenPointsInfo, Logout, LostItemSvg, MedicalSvg, ProfileSvg, TicketsSvg, TransactionsSvg, UploadedProfile } from "../svg/AllSvg";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../shared/store/auth-Slice";
import { useNavigate, useParams } from "react-router-dom";
import { dataActions } from "../../../shared/store/data-Slice";
import { useEffect, useState } from "react";
import useAxios from "../../../shared/hooks/use-axios";
import { url } from "../../../shared/utils/url";

const ProfilePopup = ({ type }: any) => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const user: any = useSelector((state: any) => state.auth.user);
    const adminUser: any = useSelector((state: any) => state.auth.adminUser);
    const [greenPoints, setGreenPoints] = useState<any>(null)
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const handleLogout = async () => {
        dispatch(dataActions.setProfile(false))
        dispatch(authActions.logout());
        if (window?.location?.pathname.includes("/admin")) {
            dispatch(authActions.adminDetail(null))
            navigate(!!params?.lang ? `/${params?.lang}/admin/login` : "/admin/login")
        } else {
            dispatch(authActions.userDetail(null))
            navigate(!!params?.lang ? `/${params?.lang}` : "/")
        }
    }

    const getProfileData = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.passenger_get}`);

            if (res && res.status === 200) {
                setGreenPoints(res?.data?.carbon_points);
            }
        } catch (error) {
            console.error("error while fetching user profile details", error);
        }
    }

    useEffect(() => { type === "passenger" && getProfileData(); }, [type]);

    return (
        <div className='absolute top-[35px] right-0 rounded-[8px] dark:bg-bgDark bg-white shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] min-w-[240px] flex flex-col focus:outline-none border dark:border-[#454545] border-[#F2F4F7] z-[1]'>
            <div className="flex flex-col items-center gap-[12px] px-[16px] py-[12px] border-b dark:border-[#454545] border-[#F2F4F7]">
                <div className="flex items-center gap-[12px] sm:flex-row flex-col">
                    <div className="min-w-[45px] h-[45px] dark:border-[#454545] dark:bg-bgDarkDull bg-[#F5F5F5] rounded-full flex items-center justify-center">
                        <UploadedProfile className="w-[25px] h-[25px] stroke-primary dark:stroke-primary" />
                    </div>
                    <div className="flex flex-col items-center sm:items-start">
                        <h6 className="text-blackDark dark:text-textBlackDull font-medium">
                            {window?.location?.pathname.includes("/admin") ? (adminUser?.first_name + " " + adminUser?.last_name) : (user?.first_name + " " + user?.last_name)}
                        </h6>
                        {!!user?.email && <h6 className="text-[#667085] dark:text-textBlackDull font-normal">
                            {user?.email}
                        </h6>}
                    </div>
                </div>

                {type === "passenger" &&
                    <div className="bg-[#36BD74] rounded-[10px] w-full min-h-[62px] relative flex items-center">
                        <button aria-label={t("aria_label.go_green_points")} title={t("aria_label.go_green_points")} className="absolute top-[7px] right-[7px] min-w-[14px] rounded-full hover:shadow-[0_0_0_1.5px_#4AFFB4] focus:shadow-[0_0_0_1.5px_#4AFFB4]" onClick={() => { dispatch(dataActions.setGoGreenPointsOpen(true)); dispatch(dataActions.setProfile(false)); }}><GreenPointsInfo /></button>
                        <GreenPoints />
                        <div className="flex flex-col">
                            <h5 className="text-white font-bold text-[16px]">{!!greenPoints ? greenPoints : 0}</h5>
                            <p className="text-white font-semibold text-[12px] whitespace-nowrap">{t("go_green_points.title")}</p>
                        </div>
                    </div>
                }
            </div>

            {(user?.role === "passenger" || user?.role === "candidate") && <>
                {type === "passenger" &&
                    <>
                        <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/profile`) : navigate(`/profile`); dispatch(dataActions.setProfile(false)); }}>
                            <div className="flex items-center gap-[10px]">
                                <ProfileSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                                <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("auth.profile.my_profile")}</h6>
                            </div>
                        </button>

                        <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/medical-details`) : navigate(`/medical-details`); dispatch(dataActions.setProfile(false)); }}>
                            <div className="flex items-center gap-[10px]">
                                <MedicalSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                                <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("profile.tabs.medical")}</h6>
                            </div>
                        </button>

                        <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/tickets`) : navigate(`/tickets`); dispatch(dataActions.setProfile(false)); }}>
                            <div className="flex items-center gap-[10px]">
                                <TicketsSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                                <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("profile.tabs.tickets")}</h6>
                            </div>
                        </button>

                        <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/transactions`) : navigate(`/transactions`); dispatch(dataActions.setProfile(false)); }}>
                            <div className="flex items-center gap-[10px]">
                                <TransactionsSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                                <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("profile.tabs.transactions")}</h6>
                            </div>
                        </button>

                        <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/lost-item`) : navigate(`/lost-item`); dispatch(dataActions.setProfile(false)); }}>
                            <div className="flex items-center gap-[10px]">
                                <LostItemSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                                <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("profile.tabs.lost_item")}</h6>
                            </div>
                        </button>

                        <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/vigilance-complaints`) : navigate(`/vigilance-complaints`); dispatch(dataActions.setProfile(false)); }}>
                            <div className="flex items-center gap-[10px]">
                                <Complaints1Svg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                                <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("profile.tabs.vigilance_complaint")}</h6>
                            </div>
                        </button>

                        <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/grievance-complaints`) : navigate(`/grievance-complaints`); dispatch(dataActions.setProfile(false)); }}>
                            <div className="flex items-center gap-[10px]">
                                <ComplaintsSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                                <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("profile.tabs.grievance_complaint")}</h6>
                            </div>
                        </button>
                    </>
                }

                {type === "recruitment" && <>
                    <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/profile`) : navigate(`/profile`); dispatch(dataActions.setProfile(false)); }}>
                        <div className="flex items-center gap-[10px]">
                            <ProfileSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                            <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("auth.profile.my_profile")}</h6>
                        </div>
                    </button>

                    <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/applied-jobs`) : navigate(`/applied-jobs`); dispatch(dataActions.setProfile(false)); }}>
                        <div className="flex items-center gap-[10px]">
                            <ApplicationSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                            <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("auth.profile.my_application")}</h6>
                        </div>
                    </button>
                </>}

                {((type === "vigilance" || type === "grievance")) &&
                    <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]" onClick={() => { !!params?.lang ? navigate(`/${params?.lang}/profile`) : navigate(`/profile`); dispatch(dataActions.setProfile(false)); }}>
                        <div className="flex items-center gap-[10px]">
                            <ProfileSvg className="min-w-[16px] fill-blackDull dark:fill-textBlackDull" />
                            <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("auth.profile.my_profile")}</h6>
                        </div>
                    </button>
                }
            </>}

            {/*<button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] border-b dark:border-[#454545] border-[#F2F4F7]">
                <div className="flex items-center gap-[10px]">
                    <Setting className="min-w-[16px] stroke-blackDull dark:stroke-textBlackDull" />
                    <h6 className="text-blackDark dark:text-textBlackDull font-medium">{t("auth.profile.settings")}</h6>
                </div>
            </button>*/}

            <button className="w-full px-[16px] py-[10px] hover:bg-[#f4f4f4] focus:bg-[#f4f4f4] dark:hover:bg-[#4c4e5e5e] dark:focus:bg-[#4c4e5e5e] rounded-b-[8px]" onClick={handleLogout} onBlur={() => dispatch(dataActions.setProfile(false))}>
                <div className="flex items-center gap-[10px]">
                    <Logout className="min-w-[16px] dark:stroke-darkDanger stroke-danger" />
                    <h6 className="text-danger dark:text-darkDanger font-medium">{t("auth.profile.logout")}</h6>
                </div>
            </button>
        </div>
    );
};

export default ProfilePopup;